import { useState } from 'react';
import './Login.css';
import PasswordInput from './PasswordInput';
import Icon from './Icon';

function ResetPassword({ token, valid, username, onSetPassword, onDone }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [error, setError]       = useState('');
  const [done, setDone]         = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (!password) { setError('Password is required.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    const err = await onSetPassword(token, password);
    if (err) { setError(err); return; }
    // On success App logs the user in and navigates away (this unmounts);
    // setDone is a harmless fallback in case navigation doesn't occur.
    setDone(true);
  }

  return (
    <div className="login-screen">
      <div className="login-card">
        <div className="login-brand"><span className="login-logo"><Icon name="brand" size={22} /></span> iBetterAgent</div>
        <h2 className="login-title">Reset Password</h2>

        {!valid ? (
          <>
            <div className="login-error">⚠ This reset link is invalid or has expired.</div>
            <button className="login-btn" onClick={onDone}>Back to Login</button>
          </>
        ) : done ? (
          <>
            <div className="login-info">✓ Your password has been changed. Please log in.</div>
            <button className="login-btn" onClick={onDone}>Back to Login</button>
          </>
        ) : (
          <form className="login-form" onSubmit={submit} noValidate>
            {username && (
              <div className="login-reset-for">Resetting password for <strong>{username}</strong></div>
            )}
            {error && <div className="login-error">⚠ {error}</div>}

            <label className="login-label">New Password</label>
            <PasswordInput className="login-input" autoFocus value={password}
              onChange={e => { setPassword(e.target.value); setError(''); }} />

            <label className="login-label">Confirm Password</label>
            <PasswordInput className="login-input" value={confirm}
              onChange={e => { setConfirm(e.target.value); setError(''); }} />

            <button type="submit" className="login-btn">Set New Password</button>
            <p className="login-switch">
              <button type="button" className="login-link" onClick={onDone}>Cancel</button>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
